module.exports = __webpack_public_path__ + "img/img7.f30132a7.png";